(function () {
  function textOf(node) {
    return (node && node.textContent ? node.textContent : '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function mountStyle() {
    if (document.getElementById('aeliza-mobile-reflection-index-style')) return;

    var style = document.createElement('style');
    style.id = 'aeliza-mobile-reflection-index-style';
    style.textContent = [
      '@media (max-width: 900px) {',
      '  .mobile-nav__link--reflection-index {',
      '    display: flex !important;',
      '    flex-wrap: wrap !important;',
      '    gap: 0.28em !important;',
      '    align-items: baseline !important;',
      '    color: inherit !important;',
      '  }',
      '  .mobile-nav__reflection-word--the,',
      '  .mobile-nav__reflection-word--reflection,',
      '  .mobile-nav__reflection-word--index { color: #2f6bff !important; }',
      '  .mobile-nav__link--sale { color: #ff0000 !important; }',
      '  .mobile-nav__link--reflection-index:hover .mobile-nav__reflection-word,',
      '  .mobile-nav__link--reflection-index:active .mobile-nav__reflection-word,',
      '  .mobile-nav__link--reflection-index:focus-visible .mobile-nav__reflection-word {',
      '    color: var(--aeliza-bg) !important;',
      '  }',
      '  .mobile-nav__subscribe { display: none !important; }',
      '  .mobile-nav__theme-toggle.mobile-nav__link {',
      '    cursor: pointer !important;',
      '    display: inline-flex !important;',
      '    align-items: baseline !important;',
      '    gap: 0.34em !important;',
      '  }',
      '  .mobile-nav__theme-word {',
      '    opacity: 0.32 !important;',
      '    color: currentColor !important;',
      '  }',
      '  .mobile-nav__theme-word.is-active {',
      '    opacity: 1 !important;',
      '  }',
      '  .mobile-nav__theme-divider {',
      '    opacity: 0.44 !important;',
      '    color: currentColor !important;',
      '  }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function buildLinkItem(label, href) {
    var item = document.createElement('li');
    item.className = 'mobile-nav__item';

    var link = document.createElement('a');
    link.className = 'mobile-nav__link';
    link.href = href;
    link.textContent = label;

    item.appendChild(link);
    return item;
  }

  function buildSaleItem() {
    var item = buildLinkItem('SALE', '/collections/sale');
    var link = item.querySelector('.mobile-nav__link');
    if (link) link.classList.add('mobile-nav__link--sale');
    return item;
  }

  function buildReflectionItem() {
    var item = document.createElement('li');
    item.className = 'mobile-nav__item mobile-nav__item--reflection-index';

    var link = document.createElement('a');
    link.className = 'mobile-nav__link mobile-nav__link--reflection-index';
    link.href = '/pages/self-reflection';
    link.setAttribute('aria-label', 'THE REFLECTION INDEX');
    link.innerHTML =
      '<span class="mobile-nav__reflection-word mobile-nav__reflection-word--the">THE</span>' +
      '<span class="mobile-nav__reflection-word mobile-nav__reflection-word--reflection">REFLECTION</span>' +
      '<span class="mobile-nav__reflection-word mobile-nav__reflection-word--index">INDEX</span>';

    item.appendChild(link);
    return item;
  }

  function themeMode() {
    return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
  }

  function updateThemeToggleStates() {
    var mode = themeMode();
    var toggles = document.querySelectorAll('.mobile-nav__theme-toggle');

    Array.prototype.forEach.call(toggles, function (toggle) {
      var dark = toggle.querySelector('[data-mobile-theme-word="dark"]');
      var light = toggle.querySelector('[data-mobile-theme-word="light"]');

      if (dark) dark.classList.toggle('is-active', mode === 'dark');
      if (light) light.classList.toggle('is-active', mode === 'light');
    });
  }

  function buildThemeToggleItem() {
    var item = document.createElement('li');
    item.className = 'mobile-nav__item mobile-nav__item--theme-toggle';

    var link = document.createElement('a');
    link.href = '#';
    link.className = 'mobile-nav__link mobile-nav__theme-toggle';
    link.setAttribute('role', 'button');
    link.setAttribute('aria-label', 'Toggle dark or light mode');
    link.innerHTML =
      '<span class="mobile-nav__theme-word" data-mobile-theme-word="dark">DARK</span>' +
      '<span class="mobile-nav__theme-divider">/</span>' +
      '<span class="mobile-nav__theme-word" data-mobile-theme-word="light">LIGHT</span>';

    link.addEventListener('click', function (event) {
      event.preventDefault();
      var next = themeMode() === 'light' ? 'dark' : 'light';
      document.documentElement.setAttribute('data-theme', next);
      try { window.localStorage.setItem('aeliza-theme-mode', next); } catch (e) {}
      updateThemeToggleStates();
    });

    item.appendChild(link);
    return item;
  }

  function findItem(items, names) {
    var found = null;
    items.forEach(function (item) {
      if (found) return;
      var label = textOf(item.querySelector('.mobile-nav__link, .mobile-nav__child-link, button, a'));
      if (names.indexOf(label) !== -1) found = item;
    });
    return found;
  }

  function colorReflectionIndex() {
    var links = document.querySelectorAll('.mobile-nav__link');
    Array.prototype.forEach.call(links, function (link) {
      var text = textOf(link);
      if (text !== 'THE REFLECTION INDEX' && text !== 'REFLECTION INDEX') return;

      link.classList.add('mobile-nav__link--reflection-index');
      link.setAttribute('aria-label', 'THE REFLECTION INDEX');
      link.innerHTML =
        '<span class="mobile-nav__reflection-word mobile-nav__reflection-word--the">THE</span>' +
        '<span class="mobile-nav__reflection-word mobile-nav__reflection-word--reflection">REFLECTION</span>' +
        '<span class="mobile-nav__reflection-word mobile-nav__reflection-word--index">INDEX</span>';
    });
  }

  function reorderMobileMenu() {
    var list = document.querySelector('.mobile-nav__list');
    if (!list || list.dataset.finalMobileOrder === 'desktop-style-toggle') return;

    var currentItems = Array.prototype.slice.call(list.children);
    var shopItem = findItem(currentItems, ['SHOP ALL', 'SHOP']) || buildLinkItem('SHOP ALL', '/collections/shop-all');
    var caseStudyItem = findItem(currentItems, ['CASE STUDY 4']) || buildLinkItem('CASE STUDY 4', '/collections/case-study-4');
    var ethosItem = findItem(currentItems, ['ETHOS']) || buildLinkItem('ETHOS', '/pages/ethos');
    var informationItem = findItem(currentItems, ['INFORMATION']) || buildLinkItem('INFORMATION', '/pages/information');
    var reflectionItem = findItem(currentItems, ['THE REFLECTION INDEX', 'REFLECTION INDEX']) || buildReflectionItem();

    list.innerHTML = '';
    list.appendChild(shopItem);
    list.appendChild(buildSaleItem());
    list.appendChild(reflectionItem);
    list.appendChild(caseStudyItem);
    list.appendChild(ethosItem);
    list.appendChild(informationItem);
    list.appendChild(buildThemeToggleItem());

    colorReflectionIndex();
    updateThemeToggleStates();
    list.dataset.finalMobileOrder = 'desktop-style-toggle';
  }

  function observeThemeChanges() {
    var observer = new MutationObserver(updateThemeToggleStates);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
  }

  function init() {
    mountStyle();
    reorderMobileMenu();
    observeThemeChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
